import { useQuery } from '@apollo/client'
import { getUserInvitationData as getUserInvitationDataGql }
   from 'src/graphql/queries/getUserInvitationData.gql'

const useUserInvitationData = (variables, options = {}) => {
   const { data, error, networkStatus, refetch, loading } = useQuery(getUserInvitationDataGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      ...options
   })

   return {
      userInvitationData: data?.getUserInvitationData,
      error,
      loading,
      networkStatus,
      refetch
   }
}

export default useUserInvitationData
